module.exports = __webpack_public_path__ + "img/王娜.a92c186b.jpg";